const afgcGroupClass = {
  /**
   * @var $root jQuery
   */
  $root: null,
  config: {
    'ajaxurl': '',
    'currentDir': '/',
    'groupId': 0,
    'action': '',
    'nonce': '',
  },
  init() {
    if ("afgcGroup" in window) {
      this.config = window.afgcGroup;
    }
    this.$root = jQuery('main.single-group');
    this.initTab();
    this.initDocuments();
  },
  initTab: function () {
    const $menuItems = this.$root.find('.group-topMenu .group-menu-item a[href^="#"]');
    const $items = this.$root.find('.group-item');
    $menuItems.on('click', (event) => {
      event.stopPropagation();
      const $menuItem = jQuery(event.currentTarget);
      $menuItems.parent().removeClass('is-active');
      $menuItem.parent().addClass('is-active');
      $items.removeClass('show');
      const currentTab = $menuItem.attr('href').replace('#', '');
      let $currentTab = $items.filter('[data-target=' + currentTab + ']');
      if (!$currentTab.length) {
        $currentTab = $items.filter('[data-target=home]');
      }
      $currentTab.addClass('show');
    });

    const location = document.location.toString();
    let found = false;
    $menuItems.each((index, element) => {
      const $element = jQuery(element);
      if (location.match(new RegExp($element.attr('href'), 'i'))) {
        $element.trigger('click');
        found = true;
        return false;
      }
    });
    if (!found) {
      $menuItems.first().trigger('click');
    }
  },
  initDocuments: function () {
    const $rootDocument = this.$root.find('.my-files');
    // $rootDocument.find('button.add-folder').on('click', function () {
    //   $rootDocument.find('.upload-file--open').show();
    // });
    $rootDocument.find('button.upload-file').on('click', function () {
      $rootDocument.find('.upload-file--open').show();
    });
    $rootDocument.find('button.upload-file-add').on('click', function () {
      $rootDocument.find('.upload-file--open').hide();
    });
    $rootDocument.find('button.upload-file-cancel').on('click', function () {
      $rootDocument.find('.upload-file--open').hide();
    });
    $rootDocument.find('button.remove-file').on('click', (event) => {
      const $target = jQuery(event.target).closest('tr');
      const documentName = $target.data('name');
      if ($target.hasClass('folder')) {
        if (confirm('Êtes vous certain de vouloir supprimer le dossier "' + documentName + '" ?' + "\n\n /!\\ Après confirmation, le dossier sera définitivement supprimé et tous les documents et ses sous dossiers contenus seront eux aussi supprimés !")) {
          this.documentActionAjax('folder-delete', {
            'name': documentName
          });
        }
      } else {
        if (confirm('Êtes vous certain de vouloir supprimer le fichier "' + documentName + '" ?' + "\n\n/!\\ Après confirmation, le fichier sera définitivement supprimé !")) {
          this.documentActionAjax('file-delete', {
            'name': documentName
          });
        }
      }
    });
    this.documentAction();
    this.documentMove($rootDocument);

    // $rootDocument.find('.dl-file').on('click', function () {
    //   const href = $(this).closest('.mf-table-row').find('.file-link').attr('href');
    //
    // });
  },
  documentMove: function ($rootDocument) {
    const $area = $rootDocument.find('.mf-table-body');
    const $movables = $rootDocument.find('.mf-table-row[draggable]');
    const $targets = $rootDocument.find('.mf-table-row.folder');

    let currentMoving = null;
    let currentTarget = null;
    $targets.on("dragover", (event) => {
      event.preventDefault();
      if (currentTarget === event.currentTarget) {
        return;
      }
      if (currentTarget) {
        jQuery(currentTarget).removeClass('moving_over');
      }
      currentTarget = event.currentTarget;
      jQuery(currentTarget).addClass('moving_over');
    });
    $targets.on("dragleave", (event) => {
      if (currentTarget) {
        jQuery(currentTarget).removeClass('moving_over');
        currentTarget = null;
      }
    });
    $movables.on("dragstart", (event) => {
      currentMoving = event.target;
      setTimeout(() => {
        jQuery(currentMoving).addClass('moving');
      }, 0);
    });
    $movables.on("dragend", () => {
      jQuery(currentMoving).removeClass('moving');
    });
    $targets.on("drop", (event) => {
      event.preventDefault();
      if (!currentMoving || !currentTarget) {
        return;
      }
      const $moving = jQuery(currentMoving);
      const $target = jQuery(currentTarget);
      let message = 'Êtes-vous certain de vouloir déplacer "' + $moving.data('name') + '" dans le dossier';
      if ($target.hasClass('parent')) {
        if (confirm(message + ' parent ?')) {
          this.documentActionAjax('document-move', {
            'name': $moving.data('name'),
            'toDir': '..',
          });
        }
      } else {
        if ($moving.data('name') !== $target.data('name')) {
          if (confirm(message + ' "' + $target.data('name') + '" ?')) {
            this.documentActionAjax('document-move', {
              'name': $moving.data('name'),
              'toDir': $target.data('name'),
            });
          }
        }
      }
      $target.removeClass('moving_over');
      $moving.removeClass('moving');
    });
  },
  documentActionAjax: function (type, data) {
    // console.log(Object.assign({
    //   'action': this.config.action,
    //   '_ajax_nonce': this.config.nonce,
    //   'type': type,
    //   'groupId': this.config.groupId,
    //   'currentDir': this.config.currentDir,
    // }, data));
    return jQuery.ajax({
      'url': this.config.ajaxurl,
      'data': Object.assign({
        'action': this.config.action,
        '_ajax_nonce': this.config.nonce,
        'type': type,
        'groupId': this.config.groupId,
        'currentDir': this.config.currentDir,
      }, data),
      /**
       *
       * @param jqXHR
       */
      'complete': (jqXHR) => {
        if (jqXHR.status !== 200) {
          if ("responseJSON" in jqXHR && "message" in jqXHR.responseJSON) {
            alert('ERREUR : ' + jqXHR.responseJSON.message);
          } else {
            alert('Une erreur inattendue est survenue.');
          }
        } else {
          if ("responseJSON" in jqXHR && "message" in jqXHR.responseJSON) {
            alert(jqXHR.responseJSON.message);
          }
          document.location.reload(true);
        }
      }
    });
  },
  documentAction: function () {
    const $modalRename = jQuery('#modal-rename');
    window.$modalRename = $modalRename;
    const $modalRenameFilename = $modalRename.find('input[name="filename"]');
    $modalRename.find('form').on('submit', (event) => {
      event.preventDefault();
      return false;
    });
    let modalRenameType = null;
    let $modalRenameRow = null;
    let modalRenameOldName = null;
    $modalRename.on('show.bs.modal', (event) => {
      const $button = jQuery(event.relatedTarget);
      // console.log('show.bs.modal', event, $button.hasClass('add-folder'));
      if ($button.hasClass('folder-add')) {
        modalRenameType = 'folder-add';
        $modalRenameRow = null;
        modalRenameOldName = null;
        $modalRenameFilename.parent().find('label > span').text('dossier');
        $modalRenameFilename.val('');
        $modalRename.parent().find('button.valid').text('Créer');
      } else {
        $modalRenameRow = $button.closest('tr');
        modalRenameType = ($modalRenameRow.find('.file-link').hasClass('folder') ? 'folder' : 'file') + '-rename';
        $modalRenameFilename.parent().find('label > span').text(modalRenameType === 'file-rename' ? 'fichier' : 'dossier');
        modalRenameOldName = $modalRenameRow.find('.file-link > span').text();
        $modalRenameFilename.val(modalRenameOldName);
        $modalRename.parent().find('button.valid').text('Renommer');
      }
    });
    $modalRename.find('button.valid').on('click', (event) => {
      if (!$modalRenameFilename.val()) {
        alert('Vous ne pouvez pas donner un nom vide');
        return;
      }
      // console.log('button.valid', event);
      if (modalRenameType === 'folder-add') {
        this.documentActionAjax('folder-add', {
          'name': $modalRenameFilename.val(),
        });
      } else {
        if (modalRenameOldName === $modalRenameFilename.val()) {
          alert('Le nom est identique, veuillez en choisir un nouveau ou annuler.');
        } else {
          this.documentActionAjax(modalRenameType, {
            'oldName': modalRenameOldName,
            'newName': $modalRenameFilename.val(),
          });
        }
      }
      $modalRename.modal('hide');
    });
  }
};

// noinspection JSUnresolvedVariable
(function () {
  afgcGroupClass.init();
  //window.t = afgcGroupClass;
})();
